import { lazyForPaint } from 'react-loosely-lazy';

export const DashboardEditableLazy = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jsm-avp-experience-dashbaord-editable-defer" */ './main'
		).then(({ DashboardEditable }) => DashboardEditable),
	{ ssr: false },
);
